module.exports = __webpack_public_path__ + "img/HCZ1.66b4032e.jpg";